import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import { setupRouteDocumentTitle } from '@/utils/routeDocumentTitle'

const routes: RouteRecordRaw[] = [
  // 网关/用户常直接打开 .../finSkillHub/index.html，此时 location 相对 base 为 index.html，需单独匹配
  { path: '/index.html', redirect: '/landing' },
  { path: '/', redirect: '/landing' },
  {
    path: '/landing',
    name: 'Landing',
    component: () => import('@/views/landing/AISkillsLanding.vue'),
    meta: { titleKey: 'route.title.landing', fullPage: true },
  },
  {
    path: '/landing/official',
    name: 'LandingOfficial',
    component: () => import('@/views/landing/LandingOfficialPage.vue'),
    meta: { titleKey: 'route.title.official', fullPage: true },
  },
  {
    path: '/landing/community',
    name: 'LandingCommunity',
    component: () => import('@/views/landing/LandingCommunityPage.vue'),
    meta: { titleKey: 'route.title.community', fullPage: true },
  },
  {
    path: '/landing/install-guide',
    name: 'LandingInstallGuide',
    component: () => import('@/views/landing/LandingInstallGuidePage.vue'),
    meta: { fullPage: true },
  },
  {
    path: '/skillhub/:slug',
    name: 'SkillDetail',
    component: () => import('@/views/skillhub/SkillDetailPage.vue'),
    meta: { fullPage: true },
  },
  {
    path: '/skillhub',
    name: 'SkillHub',
    component: () => import('@/views/skillhub/SkillBrowse.vue'),
    meta: { titleKey: 'route.title.skillHub', fullPage: true },
  },
  {
    path: '/landing/about',
    name: 'About',
    alias: '/about',
    component: () => import('@/views/landing/LandingAboutPage.vue'),
    meta: { fullPage: true },
  },
]

/** SIT 等环境若无法配置 Nginx SPA 回退，设 VITE_USE_HASH_ROUTER=true，URL 形如 /finSkillHub/#/landing，刷新不再 404 */
const history =
  import.meta.env.VITE_USE_HASH_ROUTER === 'true'
    ? createWebHashHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL)

const router = createRouter({
  history,
  routes,
  scrollBehavior(to: RouteLocationNormalized, from: RouteLocationNormalized, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    // 首屏 from 为「空路由」时，savedPosition 仍可能来自 history.state.scroll（上次离开页面时的滚动），
    // 若直接 return 会导致刷新 / 重新打开落地页时视口跳到中间。
    if (savedPosition && from.matched.length > 0) {
      return savedPosition
    }
    if (to.path === from.path && from.matched.length > 0) {
      return false
    }
    return { top: 0, left: 0 }
  },
})

setupRouteDocumentTitle(router)

export default router
